import { siteHeaderActions, siteNavItems } from "@/app/content";
import { SearchExperience } from "@/app/pages/SearchExperience";

export default function SearchPage() {
  return (
    <SearchExperience
      locale="zh-Hans"
      homeHref="/"
      searchPath="/search/"
      navItems={siteNavItems}
      actionItems={siteHeaderActions}
    />
  );
}
